// FullScreenLoader.tsx

import Loading from '../../utils/Loading';
import { ReactComponent as PuskicaLogoSarena } from '../../assets/svg/PuskicaLogoSarena.svg';

function FullScreenLoader() {
    return (
        <div className="flex items-center justify-center h-[100dvh] w-[100vw] bg-blueDark relative">
            <PuskicaLogoSarena width={'80%'} height={'80%'} />

            <div className="absolute top-0 left-0 z-10 flex items-center justify-center h-[100dvh] w-[100vw] ">
                <Loading size={70} primaryColor="#ffffff" secondaryColor="#19315f" />
            </div>
        </div>
    );
}

export default FullScreenLoader;
